import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tag from '@nib/tag';
import { Inline } from '@nib/layout';
import { validformControlTypeValues } from '../common-prop-types';
const LabelWithTag = props => {
  const {
    label,
    formControlType
  } = props;
  return /*#__PURE__*/_jsxs(Inline, {
    space: 3,
    children: [/*#__PURE__*/_jsx("span", {
      children: label
    }), formControlType && validformControlTypeValues.includes(formControlType) && /*#__PURE__*/_jsx(Tag, {
      size: "small",
      variation: formControlType === 'optional' ? 'info' : 'warning',
      children: formControlType.charAt(0).toUpperCase() + formControlType.slice(1)
    })]
  });
};
LabelWithTag.displayName = 'LabelWithTag';
export default LabelWithTag;